export default "__VITE_ASSET__CBzoVC_e__"